import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  Input,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FormGroup, Form, Label } from "reactstrap";
import BasicDetails from "./TutorsProfile/BasicDetails";
import TeachingPrefrences from "./TutorsProfile/TeachingPrefrences";
import EducationalQualification from "./TutorsProfile/EducationalQualification";

import LocationPrefrences from "./TutorsProfile/LocationPrefrences";
import PersonalInformation from "./TutorsProfile/PersonalInformation";
import Videotest from "./TutorsProfile/Videotest";
import TeachingExperiences from "./TutorsProfile/TeachingExperiences";
import Teaching from "./TutorsProfile/Teaching";
import DemoAllocated from "./TutorsProfile/DemoAllocated";
import TutorStudentClassAtt from "./TutorsProfile/Tutor-StudentClassAtt";
import Payments from "./TutorsProfile/Payments";
import tutorsModal from "models/tutors.modal";
import { helper } from "lib/helper";
import Interview from "./TutorsProfile/Interview";
import moment from "moment";
import Level from "./TutorsProfile/Level";
import Profile from "./Profile/index";
import Tutorsmodel from "../../models/tutors.modal";
import ProfileSubAdmins from "models/profile.modal";
import { toast } from "lib/helper";
import Salarytutors from "models/salary.modal";
const TutorsProfile = () => {

  const navigate = useNavigate();
  const [tutordata, settutordata] = useState();
  const [activeTab, setActiveTab] = useState("Basicdetails");
  const [isLoading, setIsLoading] = useState(true);
  const [englishvalue, setEnglishvalue] = useState("0");
  const [teachingPrefrencesIndication, setTeachingPrefrencesIndication] =
    useState(false);
  const [demoIndication, setDemoIndication] = useState(false);
  const [teachingExperienceIndication, setTeachingExperienceIndication] =
    useState(false);
  const [interviewerIndication, setInterviewerIndication] = useState(false);
  const [locationPrefrencesIndication, setLocationPrefrencesIndication] =
    useState(false);
  const [personalinformationIndication, setPersonalinformationIndication] =
    useState(false);
  const [educatuonalqualification, setEducatuonalqualification] =
    useState(false);
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const [dataList, setDataList] = useState([]);
  const [PersonalList, setPersonalList] = useState({});
  const [getprofile, setgetprofile] = useState();
  const location = useLocation();
  const params = useParams();
  const [note, setNote] = useState("no any note");
  const [available, setAvailable] = useState("not available");
  const [modal1, setModal1] = useState(false);

  const toggle1 = () => {
    setModal1(!modal1);
  };

  useEffect(() => {
    if (getprofile?.data?.data?.note) {
      setNote(getprofile.data.data.note);
    }
  }, [getprofile]);
  useEffect(() => {
    if (getprofile?.data?.data?.availability !== undefined) {
      setAvailable(
        getprofile.data.data.availability === null
          ? "not available"
          : getprofile.data.data.availability
      );
    }
  }, [getprofile]);

  const updatedata = async () => {
    const form = new FormData();
    form.append("availability", available);
    form.append("note", note);
    form.append("tutor_id", params.mid);
    Tutorsmodel.update(form)
      .then((responce) => {
        toast("updated Profile", "success");
        getprolile();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const getListData = async () => {
    // setIsLoading(true);
    await tutorsModal
      .listbyTutorsid(params?.id)
      .then((result) => {
        // setIsLoading(false);
        if (result) {
          setDataList(result?.data?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  //get tutor profile

  const getprolile = async () => {
    Tutorsmodel.Gettutorprofile(params?.mid)
      .then((responce) => {
        setgetprofile(responce);
      })
      .catch((error) => {
        console.log("errror", error);
      });
  };
  const getListDataPersonalInformation = async () => {
    setIsLoading(true);
    try {
      const data = { id: params?.mid };
      const result = await tutorsModal.PersonalInformationlist(data);
      setIsLoading(false);
      if (result) {
        setPersonalList(result?.data?.data);
        if (result?.data?.data) {
          setPersonalinformationIndication(true);
        } else {
          setPersonalinformationIndication(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  console.log("Personal Info", getprofile);
  const [interviewList, setInterviewList] = useState([]);
  const parmas = useParams();
  console.log("ff12345", interviewList);
  const getListDataByInterviewList = async () => {
    setIsLoading(true);

    await tutorsModal
      .TeachingPreferenceInterviewlist(parmas.mid)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setInterviewList(result?.data?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [profile, setProfile] = useState("");

  const getTutorsProfileData = async (id) => {
    await tutorsModal
      .TutorsProfileGet(params.id)
      .then((result) => {
        if (result) {
          console.log("profile api4 ->", result);
          setProfile(result?.data?.data);
        }
      })
      .catch((error) => {});
  };

  //get tutor detail
  const tutorDetail = async () => {
    if (params.id && params.mid) {
      Tutorsmodel.tutordetail(params?.mid, params?.id)
        .then((responce) => {
          console.log("tutor------- detail api5", responce);
          settutordata(responce);
        })
        .catch((error) => {
          //console.log("error",error)
        });
    }
  };

  useEffect(() => {
    getListData();
    if (params.mid !== "") {
      getListDataPersonalInformation();
    }
  }, [location, params?.id]);
  useEffect(() => {
    getTutorsProfileData();
    if (parmas.mid != "") {
      getListDataByInterviewList();
      getprolile();
    }
    tutorDetail();
  }, []);
  const dob = getprofile?.data?.data?.dob; // The date of birth

  // Function to calculate the age
  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust if the birth date hasn't occurred yet this year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const age = calculateAge(dob); // Get the age

  const OnChangeNoteandReason = (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    ProfileSubAdmins.update(params?.id, form)
      .then((responce) => {})
      .catch((error) => {
        console.log("error", error);
      });
  };

  const EditProfileofTutor = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("tutor_id", params.mid);
    form.append("tutor_status[]", selectedStatuses);
    Tutorsmodel.update(form)
      .then((responce) => {
        toast("updated Profile", "success");
        getprolile();
        tutorDetail();
        toggle1();
        getListData();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const [selectedStatuses, setSelectedStatuses] = useState([]); // State to track selected options

  const statusOptions = [
    "Adaptable & Reliable",
    "Demanding or Money-Focused",
    "Rigid or Difficult to Manage",
    "Premium Client Ready",
    "Not Suitable for Premium Clients",
    "Inconsistent or Unreliable",
    "Underconfident or Needs Improvement",
    "Inactive or Seeking Classes",
    "Dedicated & Professional",
    "Patient & Empathetic",
  ];

  useEffect(() => {
    if (getprofile?.data?.data?.tutor_status) {
      const tutorStatus = getprofile.data.data.tutor_status[0].split(","); // Split the string into an array
      setSelectedStatuses(tutorStatus);
    }
  }, [getprofile]);

  const handleOptionClick = (status) => {
    // Add the clicked option to the list (if not already selected)
    setSelectedStatuses((prev) => {
      if (!prev.includes(status)) {
        return [...prev, status];
      }
      return prev; // If already selected, no duplicate additions
    });
  };

  const handleDelete = (status) => {
    // Remove the selected option
    setSelectedStatuses((prev) => prev.filter((item) => item !== status));
  };
  useEffect(() => {
    if (getprofile?.data?.data?.english_fluency) {
      setEnglishvalue(getprofile.data.data.english_fluency);
    }
  }, [getprofile]);

  const [tutorsalary, setTuotorsalary] = useState();

  const tutorpayroll = async () => {
    Salarytutors.getlistbytutorid(params?.id)
      .then((respoce) => {
        setTuotorsalary(respoce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    tutorpayroll();
  }, [params?.id]);
  
  return (
    <div className="pt-7 px-4">
      <Row>
        <div className="col"></div>
      </Row>
      <Card className="shadow">
        <div style={{ border: "1px solid gray", minWidth: "100%" }}>
          <div
            className="nav flex-row nav-pills" // Change to flex-row for horizontal alignment
            id="v-pills-tab"
            role="tablist"
            aria-orientation="horizontal"
            style={{
              display: "flex", // Flex layout for horizontal alignment
              gap: "3px",
            }}
          >
            <button
              className={`nav-link ${
                activeTab === "Basicdetails" ? "active" : ""
              }`}
              id="v-pills-home-tab"
              onClick={() => handleTabClick("Basicdetails")}
              type="button"
              role="tab"
              aria-controls="Basicdetails"
              aria-selected={activeTab === "Basicdetails"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Basic Details{" "}
              <span style={{ color: "green", float: "right" }}>
                <i class="fa-regular fa-circle-check ml-4"></i>
              </span>
            </button>

            <button
              className={`nav-link ${
                activeTab === "TeachingPrefrences" ? "active" : ""
              } `}
              id="v-pills-profile-tab"
              onClick={() => handleTabClick("TeachingPrefrences")}
              type="button"
              role="tab"
              aria-controls="TeachingPrefrences"
              aria-selected={activeTab === "TeachingPrefrences"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Teaching Prefrences{" "}
              <span style={{ float: "right" }}>
                {teachingPrefrencesIndication && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!teachingPrefrencesIndication && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Educationalqualification" ? "active" : ""
              }`}
              id="v-pills-messages-tab"
              onClick={() => handleTabClick("Educationalqualification")}
              type="button"
              role="tab"
              aria-controls="Educationalqualification"
              aria-selected={activeTab === "Educationalqualification"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Educational Qualification{" "}
              <span style={{ float: "right" }}>
                {educatuonalqualification && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!educatuonalqualification && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Locationprefrences" ? "active" : ""
              }`}
              id="Videotest-tab"
              onClick={() => handleTabClick("Locationprefrences")}
              type="button"
              role="tab"
              aria-controls="Locationprefrences"
              aria-selected={activeTab === "Locationprefrences"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Location Prefrences{" "}
              <span style={{ float: "right" }}>
                {locationPrefrencesIndication && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!locationPrefrencesIndication && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${activeTab === "Payments" ? "active" : ""}`}
              id="Payments-tab"
              onClick={() => handleTabClick("Payments")}
              type="button"
              role="tab"
              aria-controls="Payments"
              aria-selected={activeTab === "Payments"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Payments{" "}
              <span style={{ float: "right" }}>
                {tutorsalary?.length == 0 && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
                {tutorsalary?.length > 0 && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Personalinformation" ? "active" : ""
              }`}
              id="Videotest-tab"
              onClick={() => handleTabClick("Personalinformation")}
              type="button"
              role="tab"
              aria-controls="Personalinformation"
              aria-selected={activeTab === "Personalinformation"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Personal Information{" "}
              <span style={{ color: "green", float: "right" }}>
                <i class="fa-regular fa-circle-check ml-4"></i>
              </span>
            </button>
            {/* <button
                    className={`nav-link ${
                      activeTab === "Videotest" ? "active" : ""
                    }`}
                    id="Videotest-tab"
                    onClick={() => handleTabClick("Videotest")}
                    type="button"
                    role="tab"
                    aria-controls="Videotest"
                    aria-selected={activeTab === "Videotest"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      minWidth: "200px",
                      borderRadius: "0",
                      borderTop: "none",
                      borderBottom: "1px solid gray",
                      fontSize: "16px",
                    }}
                  >
                    Video Question
                  </button> */}
            <button
              className={`nav-link ${
                activeTab === "Teachingexperiences" ? "active" : ""
              }`}
              id="Teachingexperiences-tab"
              onClick={() => handleTabClick("Teachingexperiences")}
              type="button"
              role="tab"
              aria-controls="Teachingexperiences"
              aria-selected={activeTab === "Teachingexperiences"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Teaching Experiences{" "}
              <span style={{ color: "green", float: "right" }}>
                {teachingExperienceIndication && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!teachingExperienceIndication && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Interview" ? "active" : ""
              }`}
              id="Teaching-tab"
              onClick={() => handleTabClick("Interview")}
              type="button"
              role="tab"
              aria-controls="Interview"
              aria-selected={activeTab === "Interview"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Interview Details{" "}
              <span style={{ float: "right" }}>
                {interviewList?.interview_date && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!interviewList?.interview_date && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Demoallocated" ? "active" : ""
              }`}
              id="Demoallocated-tab"
              onClick={() => handleTabClick("Demoallocated")}
              type="button"
              role="tab"
              aria-controls="Demoallocated"
              aria-selected={activeTab === " Demoallocated"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Demo And Class allocated{" "}
              <span style={{ float: "right" }}>
                {demoIndication && (
                  <i
                    class="fa-regular fa-circle-check ml-4"
                    style={{ color: "green" }}
                  ></i>
                )}
                {!demoIndication && (
                  <i
                    class="fa-regular fa-circle-xmark ml-4"
                    style={{ color: "red" }}
                  ></i>
                )}
              </span>
            </button>
            <button
              className={`nav-link ${activeTab === "Profile" ? "active" : ""}`}
              id="Payments-tab"
              onClick={() => handleTabClick("Profile")}
              type="button"
              role="tab"
              aria-controls="Profile"
              aria-selected={activeTab === "Profile"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",

                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Profile{" "}
              <span style={{ color: "green", float: "right" }}>
                <i class="fa-regular fa-circle-check ml-4"></i>
              </span>
            </button>
            <button
              className={`nav-link ${
                activeTab === "Tutor-StudentClassAttendance" ? "active" : ""
              }`}
              id="Tutor-StudentClassAttendance-tab"
              onClick={() =>{ 
                handleTabClick("Tutor-StudentClassAttendance");
                navigate("/admin/attendance");}}
              type="button"
              role="tab"
              aria-controls="Tutor-StudentClassAttendance"
              aria-selected={activeTab === "Tutor-StudentClassAttendance"}
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "50px",
                margin: "4px",
                borderRadius: "5px",
                borderTop: "none",
                borderBottom: "1px solid gray",
                fontSize: "16px",
              }}
            >
              Tutor - Student Attendance{" "}
              <span style={{ color: "red", float: "right" }}>
                <i class="fa-regular fa-circle-xmark ml-4"></i>
              </span>
            </button>
          </div>
        </div>
        <CardHeader
          CardHeader
          className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-center"
        >
          <Card className=" w-100" style={{ borderRadius: ".5rem" }}>
            <form onSubmit={OnChangeNoteandReason}>
              <Row className="g-0">
                <Col
                  md="3"
                  className="gradient-custom text-center text-white"
                  style={{
                    borderTopLeftRadius: ".5rem",
                    borderBottomLeftRadius: ".5rem",
                    backgroundColor: "#000f26",
                  }}
                >
                  <img
                    className=" "
                    style={{
                      width: "150px",
                      borderRadius: "10px",
                      marginTop: "60px",
                      height: "150px",
                    }}
                    src={`${
                      (getprofile?.data?.data?.profilePic &&
                        getprofile?.data?.data?.profilePic) ||
                      "https://cliply.co/wp-content/uploads/2020/09/442008571_ARTIST_AVATAR_3D_400px.gif"
                    }`}
                    alt="profileimage"
                    fluid
                  />
                  <h4 className="mt-3">
                    {" "}
                    <br />
                  </h4>
                </Col>
                <Col md="8">
                  <CardBody className="p-0">
                    <Row className="pt-1">
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Name - {dataList?.user?.first_name}{" "}
                              {dataList?.user?.last_name}
                            </span>{" "}
                            <span style={{ color: "black" }}>
                              {age ? `(${age} age)` : ""}
                            </span>{" "}
                            <br />{" "}
                          </p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Badge/Level - {getprofile?.data?.data?.badge}
                            </span>{" "}
                            <br />{" "}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-3 mb-4" />
                    <Row className="pt-1">
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Mode - {dataList?.modeOfTution}
                            </span>{" "}
                            <br />{" "}
                          </p>
                        </div>
                      </Col>

                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Joining date -{" "}
                              {moment(dataList?.user?.date_joined).format(
                                "MMM DD, YYYY"
                              )}
                            </span>{" "}
                            <br />{" "}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-0 mb-4" />
                    <Row className="pt-1">
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Status -{" "}
                              {getprofile?.data?.data?.status == null
                                ? "not available "
                                : getprofile?.data?.data?.status}
                              <span
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                }}
                                onClick={toggle}
                              >
                                {interviewList?.status && "view Offering"}
                              </span>
                            </span>{" "}
                            <br />{" "}
                            {/* {employeeDetails?.parent_department_name}{" "} */}
                          </p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Salary -{" "}
                              {getprofile?.data?.data?.salary == null
                                ? "not available"
                                : getprofile?.data?.data?.salary}
                            </span>{" "}
                            <br />{" "}
                            {/* {employeeDetails?.parent_department_name}{" "} */}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-0 mb-4" />

                    <Row className="pt-1">
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Subject - {getprofile?.data?.data?.subject}
                              <span>
                                {interviewList &&
                                  interviewList?.subjects?.map(
                                    (data, dataIndex) => (
                                      <span
                                        key={dataIndex}
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {dataIndex === dataIndex && (
                                          <>
                                            {dataIndex !== 0 && " / "}{" "}
                                            {data?.name}
                                          </>
                                        )}
                                      </span>
                                    )
                                  )}
                              </span>
                            </span>{" "}
                            <br />{" "}
                            {/* {employeeDetails?.parent_department_name}{" "} */}
                          </p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className="top-card-div">
                          <p className="card-text">
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              Availability -
                              <span>
                                <Input
                                  type="select"
                                  name="reason_for_not_available"
                                  value={available}
                                  onChange={(e) => {
                                    setAvailable(e.target.value);
                                  }}
                                >
                                  <option value="available">Avalaible</option>
                                  <option value="not available">
                                    Not available
                                  </option>
                                </Input>
                              </span>
                            </span>{" "}
                            <br />{" "}
                            {/* {employeeDetails?.parent_department_name}{" "} */}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={7}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    Status - {getprofile?.data?.data?.tutor_status}
                  </span>
                </Col>
                <Col md={5}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    English Fluency - {getprofile?.data?.data?.english_fluency}
                  </span>
                </Col>
              </Row>
              <Row className="py-2 flex justify-between">
                <Col>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Notes
                  </span>
                </Col>
              </Row>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: "5px",
                }}
              >
                <Col md={8}>
                  <Input
                    name="note"
                    onChange={(e) => setNote(e.target.value)}
                    type="textarea"
                    value={note}
                  />
                </Col>
                <Col
                  md={2}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end", // Aligns the button to the right
                  }}
                >
                  <Button onClick={updatedata}>Update</Button>
                </Col>
                <Col md={2}>
                  <Button onClick={toggle1}>Edit Profile</Button>
                </Col>
              </Row>
            </form>
          </Card>
        </CardHeader>
        <CardBody>
          <div>
            <div>
              <div>
                <div
                  className="tab-content "
                  id="v-pills-tabContent"
                  style={{
                    border: "1px solid gray",
                  }}
                >
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Basicdetails" ? "show active" : ""
                    }`}
                    id="Basicdetails"
                    role="tabpanel"
                    aria-labelledby="v-pills-home-tab"
                  >
                    {/* code */}
                    <CardBody>
                      <BasicDetails
                        dataList={dataList}
                        PersonalList={PersonalList}
                        getprofile={getprofile}
                      />
                    </CardBody>
                    {/* code */}
                  </div>

                  <div
                    className={`tab-pane fade ${
                      activeTab === "TeachingPrefrences" ? "show active" : ""
                    }`}
                    id="TeachingPrefrences"
                    role="tabpanel"
                    aria-labelledby="v-pills-profile-tab"
                  >
                    {/* code */}

                    <TeachingPrefrences
                      setTeachingPrefrencesIndication={
                        setTeachingPrefrencesIndication
                      }
                    />

                    {/* code */}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "level" ? "show active" : ""
                    }`}
                    id="TeachingPrefrences"
                    role="tabpanel"
                    aria-labelledby="v-pills-profile-tab"
                  >
                    {/* code */}

                    <Level />

                    {/* code */}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Educationalqualification"
                        ? "show active"
                        : ""
                    }`}
                    id="Educationalqualification"
                    role="tabpanel"
                    aria-labelledby="v-pills-messages-tab"
                  >
                    <EducationalQualification
                      setEducatuonalqualification={setEducatuonalqualification}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Locationprefrences" ? "show active" : ""
                    }`}
                    id="Locationprefrences"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <LocationPrefrences
                      setLocationPrefrencesIndication={
                        setLocationPrefrencesIndication
                      }
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Interview" ? "show active" : ""
                    }`}
                    id="Locationprefrences"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <Interview
                      dataListTuotrs={dataList}
                      getListDataByrefersh={getListDataByInterviewList}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Personalinformation" ? "show active" : ""
                    }`}
                    id="Personalinformation"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <PersonalInformation
                      dataList={dataList}
                      PersonalList={PersonalList}
                      getprofile={getprofile}
                      isLoading={isLoading}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Videotest" ? "show active" : ""
                    }`}
                    id="Videotest"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <Videotest />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Teachingexperiences" ? "show active" : ""
                    }`}
                    id="Teachingexperiences"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <TeachingExperiences
                      setTeachingExperienceIndication={
                        setTeachingExperienceIndication
                      }
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Teaching" ? "show active" : ""
                    }`}
                    id="Teaching"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <Teaching />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Demoallocated" ? "show active" : ""
                    }`}
                    id="Demoallocated"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <DemoAllocated setDemoIndication={setDemoIndication} />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Tutor-StudentClassAttendance"
                        ? "show active"
                        : ""
                    }`}
                    id="Tutor-StudentClassAttendance"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <TutorStudentClassAtt />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Payments" ? "show active" : ""
                    }`}
                    id="Payments"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <Payments
                      tutorsalary={tutorsalary}
                      tutorpayroll={tutorpayroll}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Profile" ? "show active" : ""
                    }`}
                    id="Payments"
                    role="tabpanel"
                    aria-labelledby="Videotest-tab"
                  >
                    <Profile
                      dataList={dataList}
                      getTutorsProfileDatarefesh={getTutorsProfileData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Interview Offering Details view</h4>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Feedback</Label>
                  <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {interviewList?.feedback}
                  </p>
                </FormGroup>
              </Col>
              <hr />

              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Offering Details</Label>
                  <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {interviewList?.offering_details}
                  </p>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modal1}
        toggle={toggle1}
        size="lg"
        style={{ maxHeight: "90vh", overflow: "hidden" }}
      >
        <ModalHeader toggle={toggle1}>
          <h4>Profile Edit</h4>
        </ModalHeader>
        <form onSubmit={EditProfileofTutor}>
          <ModalBody
            className="pt-0"
            style={{
              maxHeight: "75vh",
              overflowY: "auto",
              paddingRight: "15px",
            }}
          >
            <Row className="mb-2">
              <Col md={6}>
                <Label for="exampleEmail">First Name</Label>
                <Input
                  name="first_name"
                  id="forType"
                  type="text"
                  defaultValue={dataList?.user?.first_name}
                  placeholder="Enter First Name "
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">Last Name</Label>
                <Input
                  name="last_name"
                  id="forType"
                  type="text"
                  placeholder="Enter Last Name"
                  defaultValue={dataList?.user?.last_name}
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={6}>
                <Label for="exampleEmail">Email</Label>
                <Input
                  name="email"
                  id="forType"
                  type="text"
                  placeholder="Enter Email"
                  defaultValue={dataList?.user?.email}
                />
              </Col>
              {/*
              <Col className="mb-2" md={6}>
                <Label for="exampleEmail">Acadamic</Label>
                <Input
                  name="acadamic"
                  id="forType"
                  type="text"
                  placeholder=""
                  defaultValue={getprofile?.data?.data?.acadamic}
                />
              </Col>
              <Col md={6} className="mb-2">
                <Label for="exampleEmail">Board</Label>
                <Input
                  name="board"
                  id="forType"
                  type="text"
                  placeholder=""
                  defaultValue={getprofile?.data?.data?.board}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">Class</Label>
                <Input
                  name="class"
                  id="forType"
                  type="text"
                  placeholder=""
                  defaultValue={getprofile?.data?.data?.class}
                />
              </Col> */}
              <Col md={6} className="mb-2">
                <Label for="exampleEmail">Subject</Label>
                <Input
                  name="subject"
                  id="forType"
                  type="text"
                  placeholder=""
                  defaultValue={getprofile?.data?.data?.subject}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">Salary</Label>
                <Input
                  name="salary"
                  id="forType"
                  type="text"
                  placeholder="Acadamic"
                  defaultValue={getprofile?.data?.data?.salary}
                />
              </Col>
              <Col md={6} className="mb-2">
                <Label for="exampleEmail">Mode Of Tution</Label>
                <Input name="modeOfTution" id="forType" type="select">
                  <option value="Online">Online</option>
                  <option value="Offline">Offline</option>
                </Input>
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">Level/Badge</Label>
                <Input
                  name="badge"
                  id="forType"
                  type="select"
                  defaultValue={getprofile?.data?.data?.badge}
                  placeholder="Enter level/Badge"
                >
                  <option value="">Select</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </Input>
              </Col>
              <Col md={6}>
                <Label for="englishFluency">{`English Fluency ( ${englishvalue} )`}</Label>
                <Input
                  type="range"
                  name="english_fluency"
                  id="englishFluency"
                  min="0"
                  max="10"
                  value={englishvalue}
                  onChange={(e) => setEnglishvalue(e.target.value)}
                  className="w-full mt-3"
                />
              </Col>
            </Row>
            <Row className="mb-2"></Row>
            <Row>
              <Col md={12}>
                <div>
                  <h3>Status</h3>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {statusOptions.map((status, index) => (
                      <div
                        key={index}
                        onClick={() => handleOptionClick(status)}
                        style={{
                          padding: "5px",
                          cursor: "pointer",
                          backgroundColor: selectedStatuses.includes(status)
                            ? "#d1e7dd"
                            : "#f8f9fa",
                          marginBottom: "5px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      >
                        {status}
                      </div>
                    ))}
                  </div>
                  <h4 style={{ marginTop: "2px" }}>Selected Status:</h4>
                  <ul style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {selectedStatuses.map((status, index) => (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <span style={{ flex: 1 }}>{status}</span>
                        <button
                          onClick={(e) => {
                            e.preventDefault(); // Prevent form submission
                            handleDelete(status); // Perform delete action
                          }}
                          style={{
                            background: "#dc3545",
                            color: "#fff",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "10px",
                          }}
                        >
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <div
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#f8f9fa",
              borderTop: "1px solid #ccc",
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 15px",
              zIndex: 1050, // Ensure it stays above modal content
            }}
          >
            <Button color="secondary" onClick={toggle1}>
              Cancel
            </Button>
            <Button type="submit" color="secondary">
              Save
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default TutorsProfile;
